import { IBillItem } from '../../../types';
import { BILLS_STATUSES } from '../../../consts';

export const mapBillsToBillsTableRow = (bills: Array<IBillItem>) => (
  bills?.map((bill: IBillItem) => (
    {
      billNumber: bill?.billNumber || '',
      vendor: bill?.supplierName || '',
      dueDate: bill?.dueDate || '',
      createTime: bill?.createTime || '',
      calculatedStatus: bill?.calculatedStatus || '',
      attachment: bill?.documentId || '',
      amount: bill?.amount || 0,
      paidTime: bill?.paidTime || '',
      cancelTime: bill?.cancelTime || '',
      billId: bill?.billId || '',
      supplierId: bill?.supplierId || '',
      recurringPaymentData: bill?.recurringPaymentData || undefined,
    }))
);

export const getBillById = (billsArray: Array<IBillItem>, billId: string) => billsArray.find((billItem: IBillItem) => billItem.billId === billId);

export const isBillOverdue = (status: string, numOfOverdueDays: number) => (status === BILLS_STATUSES.PENDING || status === BILLS_STATUSES.AWAITING_DETAILS) && numOfOverdueDays > 0;

export const isBillStatusPending = (status: string) => status === BILLS_STATUSES.PENDING;
export const isBillStatusPaid = (status: string) => status === BILLS_STATUSES.PAID;
export const isBillStatusCanceled = (status: string) => status === BILLS_STATUSES.CANCELED;
export const isBillStatusAwaitingDetails = (status: string) => status === BILLS_STATUSES.AWAITING_DETAILS;

export const removeBillByBillId = (billsArr: IBillItem[], billId: string) => (
  billsArr.filter((bill: IBillItem) => bill.billId !== billId)
);

export const updateItemByExternalId = (arrOfObjs: Array<IBillItem>, billId: string, docId: string) => arrOfObjs.map((item: IBillItem) => (item?.billId === billId ? { ...item, documentId: docId } : item));
export const updateNewItemByExternalId = (arrOfObjs: Array<IBillItem>, billItem: IBillItem) => arrOfObjs.map((item: IBillItem) => (item?.billId === billItem.billId ? billItem : item));

export const removeDuplicateBillsByBillId = (bills: Array<IBillItem> | []): Array<IBillItem> | [] => {
  const billIdsSet = new Set(bills.map((bill: IBillItem) => bill.billId));
  const billIdsArray = Array.from(billIdsSet);
  return billIdsArray.map((billId) => bills.filter((bill: IBillItem) => bill.billId === billId)?.[0]);
};
